import { v4 as uuidv4 } from 'uuid';
import img1 from '../../assets/images/hero-img.png';

const heroSliderData = [
  {
    id: uuidv4(),
    shadowHeading: 'Hitech',
    mainHeading: 'The best buildings in the world',
    subHeading:
      'The most important distinguishing feature of the construction of our buildings is the absence of stereotypes.',
    img: img1,
    btnText: 'Learn More',
    btnLink: '/',
  },

  {
    id: uuidv4(),
    shadowHeading: 'Hitech',
    mainHeading: 'The best buildings in the world',
    subHeading:
      'The most important distinguishing feature of the construction of our buildings is the absence of stereotypes.',
    img: img1,
    btnText: 'Learn More',
    btnLink: '/',
  },
];

export default heroSliderData;
